module.exports = __webpack_public_path__ + "img/en_tip.096cc3a0.png";